(() => {
  const config = document.querySelector('[data-papacou-config]');
  if (!config) return;
  const strings = JSON.parse(config.textContent);
  Object.assign(strings,JSON.parse(document.getElementById('pc-classic-stitch-strings').textContent));
  const money = new Intl.NumberFormat(document.documentElement.lang || 'sk', { style: 'currency', currency: config.dataset.currency });


  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  let pending = false;
  const field = (root, id) => root.querySelector(`[id^="tcustomizer-field-${id}-"]`);
  const checked = (el) => Array.from(el?.querySelectorAll('input[type="checkbox"]:checked') || []);
  const laserIds = [349395,157937,18070,686525,985549];
  const sideFields = (root,id) => {
    const elements = [];
    let next = field(root,id)?.nextElementSibling;
    while (next && !laserIds.some(other=>next === field(root,other))) {
      if (next.matches('.tcustomizer-field--Text, .tcustomizer-field--FileUpload')) elements.push(next);
      next = next.nextElementSibling;
    }
    return elements;
  };
  const helper = (el, key, heading = false) => {
    if (!el) return;
    const id = `pc-${key}`;
    let node = document.getElementById(id);
    if (!node) {
      node = document.createElement(heading ? 'h3' : 'p');
      node.id = id;
      node.className = heading ? 'pc-step-heading' : 'pc-field-help';
      if (heading) el.before(node);
      else if (key === 'laser_hint') {
        const label = el.querySelector('.tcustomizer-field__heading');
        if (label) label.after(node);
        else el.prepend(node);
      } else el.append(node);
    }
    text(node, strings[key]);
  };
  const charmStrings = JSON.parse(document.getElementById('pc-charm-choice-strings').textContent);
  strings.error_charms = charmStrings.error;
  let charmMode = 'none';
  let charmDraft = '';
  const setCharmValue = (input, value) => {
    if (input.value === value) return;
    const proto = input.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto,'value').set.call(input,value);
    input.dispatchEvent(new Event('input',{bubbles:true}));
    input.dispatchEvent(new Event('change',{bubbles:true}));
  };
  const updateCharms = (root) => {
    const el = field(root,872434);
    const input = el?.querySelector('.tcustomizer__text-field');
    if (!input) return;
    let choices = el.querySelector('.pc-charms-selector');
    if (!choices) {
      choices = document.createElement('div');
      choices.className = 'pc-charms-selector';
      choices.setAttribute('role','radiogroup');
      choices.setAttribute('aria-label',strings.charms);
      ['none','yes'].forEach(value => {
        const label = document.createElement('label');
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'pc-charms-choice';
        radio.value = value;
        radio.checked = value === charmMode;
        const caption = document.createElement('span');
        caption.textContent = charmStrings[value];
        label.append(radio,caption);
        choices.append(label);
        radio.addEventListener('change',() => {
          if (!radio.checked) return;
          if (charmMode === 'yes') charmDraft = input.value;
          charmMode = value;
          setCharmValue(input,value === 'yes' ? charmDraft : charmStrings.none);
          updateCharms(root);
          schedule();
          if (value === 'yes') input.focus({preventScroll:true});
        });
      });
      el.querySelector('.tcustomizer-field__heading')?.after(choices);
      setCharmValue(input,charmMode === 'yes' ? charmDraft : charmStrings.none);
    }
    const wantsCharms = charmMode === 'yes';
    if (!wantsCharms) setCharmValue(input,charmStrings.none);
    input.required = wantsCharms;
    input.setAttribute('aria-required',String(wantsCharms));
    input.setAttribute('aria-label',strings.charms);
    [el.querySelector('.tcustomizer-field__input'),el.querySelector('#pc-charms_hint')].forEach(node => { if (node) node.hidden = !wantsCharms; });
    const inspiration = el.querySelector('#pc-charms-inspiration');
    if (inspiration) inspiration.hidden = false;
  };
  const validate = () => {
    const root = document.querySelector('.pc-configurator');
    if (!root) return true;
    root.querySelectorAll('.pc-field-error').forEach(el => el.remove());
    root.querySelectorAll('[aria-invalid]').forEach(el => el.removeAttribute('aria-invalid'));
    const errors = [];
    const charmField = field(root,872434);
    if (charmMode === 'yes' && !charmField?.querySelector('.tcustomizer__text-field')?.value.trim()) errors.push([charmField,'error_charms']);
    const stitch = root.querySelector('#pc-classic-stitch');
    if (stitch?.querySelector('[name="pc-stitch-enabled"]:checked')?.value === 'yes') {
      if (!stitch.querySelector('.pc-thread__grid input:checked')) errors.push([stitch,'error_stitch_colour']);
      if (!field(root,662525)?.querySelector('input[value="Chcem obšitie"]:checked')) errors.push([stitch,'error_stitch_unavailable']);
    }
    if (!checked(field(root,220579)).length) errors.push([field(root,220579),'error_eyelets']);
    if (!checked(field(root,667408)).length) errors.push([field(root,667408),'error_elastic']);
    if (checked(field(root,674810)).length > 1) errors.push([field(root,674810),'foil_single_error']);
    if (checked(field(root,674810)).length && !field(root,684923)?.querySelector('.tcustomizer__text-field')?.value.trim()) errors.push([field(root,684923),'error_foil']);
    const laserIds = [349395,157937,18070,686525,985549];
    laserIds.forEach(id => {
      const el = field(root,id);
      if (!checked(el).length) return;
      let next = el.nextElementSibling;
      while (next && !laserIds.some(other => next === field(root,other))) {
        if (next.matches('.tcustomizer-field--Text')) {
          if (!next.querySelector('.tcustomizer__text-field')?.value.trim()) errors.push([next,'error_laser']);
          break;
        }
        next = next.nextElementSibling;
      }
    });
    errors.forEach(([el,key]) => {
      if (!el) return;
      const node = document.createElement('p');
      node.className = 'pc-field-error';
      node.setAttribute('role','alert');
      text(node,strings[key]);
      el.append(node);
      el.querySelectorAll('input:not([type=number]),textarea').forEach(input => input.setAttribute('aria-invalid','true'));
    });
    const first = errors[0]?.[0];
    if (first) {
      first.scrollIntoView({block:'center',behavior:'smooth'});
      first.querySelector('input:not([type=number]),textarea')?.focus({preventScroll:true});
    }
    return errors.length === 0;
  };
  const update = () => {
    pending = false;
    const root = document.querySelector('.tcustomizer-customization-form');
    if (!root || !root.querySelector('[id^="tcustomizer-field-220579-"]')) return;
    root.classList.add('pc-configurator');
    if (!document.getElementById('pc-classic-stitch')) field(root,872434)?.after(document.getElementById('pc-classic-stitch-template').content.cloneNode(true));
    const stitch = root.querySelector('#pc-classic-stitch');
    const nativeStitch = field(root,662525);
    if (nativeStitch) nativeStitch.hidden = true;
    const chosenStitch = stitch?.querySelector('[name="pc-stitch-enabled"]:checked')?.value === 'yes' ? 'Chcem obšitie' : 'Bez obšitia';
    const nativeChoice = nativeStitch?.querySelector(`input[value="${chosenStitch}"]`);
    if (nativeChoice && !nativeChoice.checked) nativeChoice.click();
    const stitchEnabled = stitch?.querySelector('[name="pc-stitch-enabled"]:checked')?.value === 'yes';
    const palette = stitch?.querySelector('.pc-stitch-palette');
    if (palette) palette.hidden = !stitchEnabled;
    stitch?.querySelectorAll('.pc-thread__grid input').forEach(input => { input.disabled = !stitchEnabled; input.required = stitchEnabled; });
    text(root.querySelector('.tcustomizer__heading h3'), strings.heading);
    text(root.querySelector('[class*="tcustomizer-field-528120-"]'), strings.included);
    [674810,...laserIds].forEach(id => field(root,id)?.classList.add('pc-personal-choice'));
    field(root,674810)?.classList.add('pc-foil-choice');
    const foil = field(root,674810);
    foil?.querySelectorAll('.tcustomizer-checkbox').forEach(option => {
      const value = option.querySelector('input')?.value;
      const colour = value === 'Strieborná' ? 'silver' : value === 'Zlatá' ? 'gold' : null;
      const label = option.querySelector('.tcustomizer-checkbox__label');
      const template = colour && document.getElementById('pc-foil-' + colour + '-template');
      if (label && template && !label.querySelector('.pc-foil-photos')) label.prepend(template.content.cloneNode(true));
    });
    if (foil && !document.getElementById('pc-foil-example-note')) {
      const template = document.getElementById('pc-foil-note-template');
      if (template) foil.append(template.content.cloneNode(true));
    }
    field(root,684923)?.classList.add('pc-personal-detail');
    const charms = field(root,872434);
    charms?.classList.add('pc-personal-detail','pc-charms');
    if (charms && !document.getElementById('pc-charms-inspiration')) charms.querySelector('.tcustomizer-field__heading')?.after(document.getElementById('pc-horse-charms-template').content.cloneNode(true));
    const headings = {220579:'eyelets',667408:'elastic',872434:'charms',674810:'foil',684923:'foil_text',349395:'laser',157937:'back',18070:'inside_left',686525:'inside_outer',985549:'inside_right'};
    Object.entries(headings).forEach(([id,key]) => text(root.querySelector(`[id^="tcustomizer-field-${id}-"] > .tcustomizer-field__heading > span`), strings[key]));
    helper(field(root,220579),'step_included',true);
    helper(field(root,674810),'step_personal',true);
    [[220579,'eyelet_hint'],[667408,'elastic_hint'],[872434,'charms_hint'],[674810,'foil_hint'],[349395,'laser_hint']].forEach(([id,key]) => helper(field(root,id),key));
    [[872434,'charms_placeholder'],[684923,'foil_placeholder']].forEach(([id,key]) => {
      const input = field(root,id)?.querySelector('.tcustomizer__text-field');
      if (input) input.placeholder = strings[key];
    });
    root.querySelectorAll('.tcustomizer-field--Text').forEach(el => {
      if (el === field(root,872434) || el === field(root,684923)) return;
      const input = el.querySelector('.tcustomizer__text-field');
      if (input) input.placeholder = strings.laser_placeholder;
    });
    root.querySelectorAll('.tcustomizer__btn-check').forEach(input => {
      if (input.getAttribute('aria-label') !== input.value) input.setAttribute('aria-label',input.value);
    });
    root.querySelectorAll('.tcustomizer-field--Description').forEach(el => { if (el.textContent.trim() === 'null') el.hidden = true; });
    root.querySelectorAll('.tcustomizer-field--FileUpload').forEach(el => {
      const input = el.querySelector('input[type="file"]');
      if (input) text(el.querySelector('.tcustomizer-file-text--subdued'), input.accept.split(',').join(', '));
    });
    laserIds.forEach(id => {
      const side = field(root,id)?.querySelector('input[type="checkbox"]')?.value;
      if (!side) return;
      sideFields(root,id).forEach(el=>{
        el.classList.add('pc-personal-detail');
        const key = el.matches('.tcustomizer-field--FileUpload') ? 'upload' : 'laser_instructions';
        let label = el.querySelector('.tcustomizer-field__heading');
        if (!label) {
          label = document.createElement('div');
          label.className = 'tcustomizer-field__heading';
          label.append(document.createElement('span'));
          el.prepend(label);
        }
        text(label.querySelector('span'),`${strings[key]} · ${side}`);
      });
    });
    root.querySelectorAll('.tcustomizer__text-field--max-characters').forEach(el => {
      const input = el.closest('.tcustomizer-field').querySelector('input[maxlength]');
      if (input) text(el, strings.limit.replace('{n}', input.maxLength));
    });
    root.querySelectorAll('.tcustomizer-field--Text').forEach(el => {
      const input = el.querySelector('.tcustomizer__text-field');
      const label = el.querySelector('.tcustomizer-field__heading');
      if (input && label) {
        if (!input.id) input.id = `${el.id}-text`;
        if (label.htmlFor !== input.id) label.htmlFor = input.id;
      }
    });
    updateCharms(root);
    let summary = document.getElementById('pc-config-total');
    if (!summary) {
      summary = document.createElement('div');
      summary.id = 'pc-config-total';
      summary.setAttribute('aria-live','polite');
      root.after(summary);
    }
    let extra = stitchEnabled ? 25 : 0;
    let known = true;
    root.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(input => {
      if (input.closest('[id^="tcustomizer-field-662525-"]')) return;
      const label = root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      const addon = label && label.querySelector('.tcustomizer-addon');
      if (!addon) return;
      const raw = addon.textContent.replace(/\s/g,'');
      const matches = raw.match(/[\d.,]+/g);
      if (!matches || matches.length !== 1 || raw.includes('%')) { known = false; return; }
      const value = Number(matches[0].replace(/\.(?=\d{3}(?:\D|$))/g,'').replace(',','.'));
      if (Number.isFinite(value)) extra += value; else known = false;
    });
    const form = root.closest('form');
    const variantId = form?.querySelector('[name="id"]')?.value;
    const variant = strings.variants.find(v => String(v.id) === variantId) || (strings.variants.length === 1 ? strings.variants[0] : null);
    summary.hidden = !known || !variant;
    if (known && variant) {
      const selections = [220579,667408,674810].map(id => {
        const label = id === 220579 ? strings.eyelets : id === 667408 ? strings.elastic : strings.foil_choice;
        const values = checked(field(root,id)).map(input => input.value).join(', ');
        return `${label}: ${values || (id === 674810 ? strings.no_personal : strings.not_selected)}`;
      });
      const charms = field(root,872434)?.querySelector('.tcustomizer__text-field')?.value.trim();
      if (charms) selections.splice(2,0,`${strings.charms}: ${charms}`);
      const foilText = field(root,684923)?.querySelector('.tcustomizer__text-field')?.value.trim();
      if (foilText && checked(field(root,674810)).length) selections[selections.length - 1] += ` · ${foilText}`;
      laserIds.forEach(id=>{
        const selected = checked(field(root,id));
        if (!selected.length) return;
        sideFields(root,id).forEach(el=>{
          const value = el.querySelector('.tcustomizer__text-field')?.value.trim();
          const sideNames = {157937:strings.back,18070:strings.inside_left,686525:strings.inside_outer,985549:strings.inside_right};
          const sideName = sideNames[id] || selected[0].value;
          if (el.matches('.tcustomizer-field--Text')) selections.push(`${strings.laser_choice} · ${sideName}: ${value || strings.not_selected}`);
          const upload = el.querySelector('input[type="file"]');
          const files = Array.from(el.querySelectorAll('.tcustomizer-file-item__name')).map(node=>node.textContent.trim()).filter(Boolean);
          if (!files.length && upload?.files?.length) files.push(...Array.from(upload.files).map(file=>file.name));
          if (files.length) selections.push(`${sideName} · ${strings.upload}: ${files.join(', ')}`);
        });
      });
      selections.splice(3,0,strings.stitch_label + ': ' + (stitchEnabled ? (stitch.querySelector('.pc-thread__grid input:checked')?.value || strings.not_selected) + ' (+25 €)' : strings.stitch_none));
      const signature = JSON.stringify([selections,variant.price,extra]);
      if (summary.dataset.content !== signature) {
        summary.dataset.content = signature;
        const title = document.createElement('h3');
        title.textContent = strings.step_review;
        const list = document.createElement('dl');
        selections.forEach(selection=>{
          const colon = selection.indexOf(':');
          const row = document.createElement('div');
          const label = document.createElement('dt');
          const value = document.createElement('dd');
          label.textContent = selection.slice(0,colon);
          value.textContent = selection.slice(colon + 1).trim();
          row.append(label,value);
          list.append(row);
        });
        const prices = document.createElement('div');
        prices.className = 'pc-review-prices';
        [[strings.base,money.format(variant.price/100)],[strings.extras,money.format(extra)],[strings.total,money.format(variant.price/100+extra)]].forEach(([label,value],index)=>{
          const row = document.createElement('div');
          row.className = index === 2 ? 'pc-review-total' : 'pc-review-price';
          const name = document.createElement('span');
          const amount = document.createElement('strong');
          name.textContent = label;
          amount.textContent = value;
          row.append(name,amount);
          prices.append(row);
        });
        const shipping = document.createElement('small');
        shipping.textContent = strings.shipping;
        const availability = document.createElement('p');
        availability.className = 'pc-made-to-order';
        availability.hidden = !variant.available;
        availability.textContent = strings.made_to_order;
        summary.replaceChildren(title,list,prices,availability,shipping);
      }
    }
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  const main = document.querySelector('main');
  if (main) new MutationObserver(schedule).observe(main, {childList:true,subtree:true,characterData:true});
  document.addEventListener('change',event => {
    const root = event.target.closest('.pc-configurator');
    if (root && event.target.matches('input[type=checkbox]:checked') && event.target.closest('[id^="tcustomizer-field-674810-"]')) {
      checked(field(root,674810)).filter(input=>input!==event.target).forEach(input=>input.click());
    }
    if (root && event.target.matches('input[type=checkbox]:checked') && event.target.closest('[id^="tcustomizer-field-220579-"]')) {
      const none = event.target.value === 'Bez';
      checked(field(root,220579)).filter(input=>input!==event.target && (none || input.value === 'Bez')).forEach(input=>input.click());
    }
    if (root) event.target.closest('.tcustomizer-field')?.querySelectorAll('.pc-field-error').forEach(el=>el.remove());
    schedule();
  });
  document.addEventListener('input',event => {
    const el = event.target.closest('.pc-configurator .tcustomizer-field');
    if (el) {
      el.querySelectorAll('.pc-field-error').forEach(node=>node.remove());
      el.querySelectorAll('[aria-invalid]').forEach(node=>node.removeAttribute('aria-invalid'));
    }
    schedule();
  });
  document.addEventListener('click',event => {
    if (!event.target.closest('#tcustomizer-add, button[name="add"]')) return;
    if (!validate()) { event.preventDefault(); event.stopImmediatePropagation(); }
  },true);
  document.addEventListener('submit',event => {
    if (!event.target.querySelector('.pc-configurator')) return;
    if (!validate()) { event.preventDefault(); event.stopImmediatePropagation(); }
  },true);
  const originalFetch = window.fetch;
  window.fetch = function(resource, init) {
    if (!init?.byTcustomizer || !(init.body instanceof FormData) || !/\/cart\/add\.js(?:[?#]|$)/.test(String(resource))) return originalFetch.apply(this, arguments);
    const data = new FormData;
    init.body.forEach((value,key)=>data.append(key,value));
    const entries = Array.from(data.entries());
    const parts = key => key.match(/[^\[\]]+/g) || [];
    const main = entries.find(([key,value])=>{const p=parts(key);return p[0]==='items' && p[2]==='id' && strings.variants.some(v=>String(v.id)===String(value));});
    if (!main) return originalFetch.apply(this, arguments);
    if (!validate()) return Promise.reject(new Error(strings.error_charms));
    const index = parts(main[0])[1];
    // Keep the customer-facing foil price consistent through Shopify checkout.
    entries.forEach(([key,value]) => {
      const path = parts(key);
      if (path[0] === 'items' && path[1] === index && path[2] === 'properties' && path[3] === '4. Hot Foil Stamp (+20€)') {
        data.delete(key);
        data.set(`items[${index}][properties][Razba fóliou (+25 €)]`,value);
      }
    });
    const stitch = document.getElementById('pc-classic-stitch');
    if (stitch?.querySelector('[name="pc-stitch-enabled"]:checked')?.value !== 'yes') return originalFetch.call(this, resource, {...init,body:data});
    const colour = stitch.querySelector('.pc-thread__grid input:checked')?.value;
    if (!colour || !document.querySelector('[id^="tcustomizer-field-662525-"] input[value="Chcem obšitie"]:checked')) return Promise.reject(new Error(strings.error_stitch_unavailable));
    data.set(`items[${index}][properties][Obšitie po obvode]`,colour + ' (+25 €)');
    return originalFetch.call(this, resource, {...init,body:data});
  };
  update();
})();




